var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7601886TopArrowUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6600;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,20.2c-0.4,0.4-1,0.4-1.4,0L16,13.9l-6.3,6.3c-0.4,0.4-1.1,0.3-1.4-0.1c-0.3-0.4-0.3-0.9,0-1.3l7-7 c0.4-0.4,1-0.4,1.4,0l7,7C24.1,19.2,24,19.8,23.7,20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7601886TopArrowUpdate);
export default __webpack_public_path__ + "static/media/7601886_top_arrow-update.d1de4cef8adb810be29f8077fd1ec4c0.svg";
export { ForwardRef as ReactComponent };